import http from './http-service'
import config from '../config/constant'
import { store } from '../store'

  const getSendToMobileList = async (data) => {
    try {
        
      const reqParams = {
        ...data,
        requestId: "SENDTOMOBILEWALLETLIST"
      }
      const response = await http.post(config.portfolio.getWalletList, reqParams)
      return { status: response.status, data: response.data }
    } catch (err) {
      return Promise.reject(err)
    }
  }

const SentToMobileService = {
    getSendToMobileList
}

export default SentToMobileService
